import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBagShopping, faStore} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../helper/api";

export default function ProductInfo(){
    const [data,setData] = useState(null)
    useEffect(() => {
        (  async () => {
            const res = await ApiRoute.analytics.widget.productInfo.fn({
                shop_id : shopId()
            })
            if (res?.status_code === 200){
                setData(res.results)
            }
        } )()
    }, []);
    return (
        <div className="main-content purple-shadow p-3">
            <Link to="" className="grid gap-3">
                <div className="flex justify-between text-lg items-center mb-4">
                    <span className="text-13">محصولات</span>
                    <FontAwesomeIcon className="text-lg rounded-full p-3 aspect-square bg-[#ffffff33]"
                                     icon={faBagShopping}/>
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات وارد شده امروز</span>
                    {data ? <span className="text-xs">{data.today_created}</span> : <div className={`x2-loader`}></div>}
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات وارد شده هفته</span>
                    {data ? <span className="text-xs">{data.week_created}</span> : <div className={`x2-loader`}></div>}
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات وارد شده ماه</span>
                    {data ? <span className="text-xs">{data.month_created}</span> : <div className={`x2-loader`}></div>}
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات منتشر شده امروز</span>
                    {data ? <span className="text-xs">{data.today_published}</span> : <div className={`x2-loader`}></div>}
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات منتشر شده هفته</span>
                    {data ? <span className="text-xs">{data.week_published}</span> : <div className={`x2-loader`}></div>}
                </div>
                <div className="flex justify-between items-center pl-2">
                    <span className="text-11">تعداد محصولات منتشر شده ماه</span>
                    {data ? <span className="text-xs">{data.month_published}</span> : <div className={`x2-loader`}></div>}
                </div>
            </Link>
        </div>
    )
}